import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import type { BlogDetailComments } from "./types";

export const localStateSelector = makeModuleStateSelector<BlogDetailComments.State>(defaultState, previewState);
